<template>
  <v-container class="my-1 py-1">
    <v-layout align-center justify-space-around row wrap>
      <v-flex xs0 sm1 md1 lg1></v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Deposit Amount</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.deposit_amount)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Other Advances</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.other_advance)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Transfer Amount</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.trans_amount)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Misc Deduction</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.month_deduction)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Net Deposit</div>
          <div
            v-if="caculateTotalAverage.net_deposit < 15000"
            class="red--text subheading font-weight-medium card body pa-1"
          >${{formatPrice(caculateTotalAverage.net_deposit)}}</div>
          <div
            v-else
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.net_deposit)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs0 sm1 md1 lg1></v-flex>
      <v-flex xs0 sm1 md1 lg1></v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Number of Deposits</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >{{formatPrice(caculateTotalAverage.number_deposit)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Negative Days</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >{{formatPrice(caculateTotalAverage.negative_days)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Average Daily Balance</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.daily_balance)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Beginning Balance</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.month_monthly_beginning_balance)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs4 sm2 md2 lg2 text-xs-center>
        <v-card>
          <div class="caption grey--text">Avg Ending Balance</div>
          <div
            class="subheading font-weight-regular card body pa-1"
          >${{formatPrice(caculateTotalAverage.month_monthly_ending_balance)}}</div>
        </v-card>
      </v-flex>
      <v-flex xs0 sm1 md1 lg1></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    caculateTotalAverage: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatPrice(value) {
      if (Number.isNaN(value)) {
        return 0.0;
      }
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style scoped>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  height: 25px;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  line-height: 1;
  font-size: 14px;
}
.avgContainer {
  margin-top: -20px;
  margin-bottom: -40px;
}
</style>
